(function () {
    'use strict';

    angular
        .module('bcmModule')
        .controller('biaResponsibilityResourceReqController', Controller);

    Controller.$inject = ['$scope', 'adminReferenceDataService'];

    function Controller($scope, adminReferenceDataService) {

        if (_.isUndefined($scope.ctrlCtxt)) $scope.ctrlCtxt = {};

        $scope.locations = [];

        init();

        // Save Changes — delegates to parent scope via onBoxModelSaveChanges callback
        $scope.saveChanges = function (form) {
            if (form.$invalid) return;
            $scope.onBoxModelSaveChanges();
        };

        // Cancel — delegates to parent scope close callback
        $scope.onModalClose = function () {
            $scope.close();
        };

        function init() {
            // BCMLocation is on ItemType 'PSPEmployee' (ID 16)
            adminReferenceDataService
                .getLookupAttributeValues('PSPEmployee')
                .then(function (lookupAttributes) {
                    if (lookupAttributes.BCMLocation) {
                        $scope.locations = lookupAttributes.BCMLocation.LookupAttributeValues || [];
                    }
                })
                .catch(function () {
                    $scope.locations = [];
                });
        }
    }
})();
